import React, { useState } from "react"
import PropTypes from "prop-types"
import {
  Modal,
  ModalHeader
} from "reactstrap"
import i18n from "../../../i18n"

import Step1 from "./Step1";
import Step2 from "./Step2";
import Step3 from "./Step3";

const ModifyRoutingModal = (props) => {

  const { isOpen, toggle, setShowModalModify, setModifyRoutingModal, listModifyRouting, setSelectedRoutingModifiedId } = props;

  const [step, setStep] = useState(1);
  const [selectRouting, setSelectRouting] = useState(null);
  const [newAddress, setNewAddress] = useState(null);
  const [newDestination, setNewDestination] = useState(null);

  return (
    <Modal
      isOpen={isOpen}
      role="dialog"
      autoFocus={true}
      centered={true}
      className="ModifyRoutingModal"
      tabIndex="-1"
      toggle={toggle}
      backdrop={'static'}
      id="staticBackdrop"
      size={selectRouting ? "l" : "xl"}
    >
      <div className="modal-content">
        <ModalHeader toggle={toggle}>{i18n.t("ModifyRouting")}</ModalHeader>
        {(() => {
            switch(step) {
              case 1:
                return <Step1
                         listModifyRouting={listModifyRouting}
                         setSelectRouting={setSelectRouting}
                         setSelectedRoutingModifiedId={setSelectedRoutingModifiedId}
                         setModifyRoutingModal={setModifyRoutingModal}
                         setStep={setStep}></Step1>
              case 2:
                return <Step2
                         setShowModalModify={setShowModalModify}
                         setSelectRouting={setSelectRouting}
                         setNewAddress={setNewAddress}
                         setNewDestination={setNewDestination}
                         selectRouting={selectRouting}
                         setStep={setStep}></Step2>
              case 3:
                return <Step3
                         setShowModalModify={setShowModalModify}
                         newAddress={newAddress}
                         selectRouting={selectRouting}
                         newDestination={newDestination}
                         setSelectRouting={setSelectRouting}
                         setModifyRoutingModal={setModifyRoutingModal}
                         setStep={setStep}></Step3>
            }
        })()}
      </div>
    </Modal>
  )
}

ModifyRoutingModal.propTypes = {
  setModifyRoutingModal: PropTypes.func,
  setShowModalModify: PropTypes.func,
  toggle: PropTypes.func,
  setSelectedRoutingModifiedId: PropTypes.func,
  isOpen: PropTypes.bool
}

export default ModifyRoutingModal;

